import { SwapVerticalVariantIcon } from './SwapVerticalVariantIcon';

/**
 * author: Google
 * id FC1C62DB-A06D-48F8-962F-F60FE41E4F65
 * name swap-vertical-variant
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/swap-vertical-variant.svg
 * tags
 * - Arrow 
 */
export const SwapCallsIcon = SwapVerticalVariantIcon;
export default SwapCallsIcon